import 'poly-eshop4/eshop/ui/js/admin';
